export const device = {
    get pixelRatio() {
        return window.devicePixelRatio || 1;
    },
};
